module.exports = __webpack_public_path__ + "img/ConsejosUtiles.c678b99c.svg";